import axiosClient from "./axiosClients";

const uri = "/categories";

class CategoryApi {
  getAll = () => {
    return axiosClient.get(uri);
  };

  getById = (id) => {
    return axiosClient.get(`${uri}/${id}`);
  };

  delete = (id) => {
    let url = `${uri}/${id}`;
    return axiosClient.delete(url);
  };

  create = (data) => {
    return axiosClient.post(uri, data);
  };
}
const categoryApi = new CategoryApi();
export default categoryApi;
